import React,{useEffect,useState} from 'react';
import { View, Image,ScrollView,TouchableOpacity ,StyleSheet,Dimensions} from 'react-native';
import { Avatar, Card, Text,IconButton,Divider,Appbar ,Snackbar, ActivityIndicator,FAB} from 'react-native-paper';
import TextTicker from 'react-native-text-ticker';
import { CommonActions } from '@react-navigation/native';


const sportIcons = { 
  
  "اسپینینگ":
  require("../assets/sportsicons/spin.png"),

  "ایروبیک":
  require("../assets/sportsicons/rhytm.png"),

  "بدنسازی":
  require("../assets/sportsicons/gym.png"),

  "تمرینات فانکشنال / کراسفیت":
  require("../assets/sportsicons/cf.png"),

  "تمرینات لس میلز":
  require("../assets/sportsicons/bp.png"),

  "تمرینات معلق":
  require("../assets/sportsicons/trx.png"),

  "جامپینگ فیتنس":
  require("../assets/sportsicons/jump.png"),

  "فیتنس":
  require("../assets/sportsicons/fit.png"),

  "دوچرخه سواری":
  require("../assets/sportsicons/bike.png"),

  "ورزش های آبی":
  require("../assets/sportsicons/swim.png"),

  "ورزش های آزاد":
  require("../assets/sportsicons/free.png"),

  "ورزش کودکان":
  require("../assets/sportsicons/kids.png"),

  "کیک بوکس / رزمی":
  require("../assets/sportsicons/kb.png"),

  "یوگا / پیلاتس":
  require("../assets/sportsicons/yoga.png"),

  "متفرقه":
  require("../assets/sportsicons/other.png"),

} ;

const MyAvatar = props => <Avatar.Image {...props}  size={48} source={{uri : global.image.uri}} />

const TimeStamp = props => {
  return(
    <View style={{flexDirection:'row', alignItems:'center', marginTop:-5}}>
      <IconButton icon='clock-outline' style={{margin:0}}/>
      <View style={{width:35}}>
         <Text style={{fontSize:10}}>
         {props.start} 
         </Text>
         <Text style={{fontSize:10}}>
           {props.end}
         </Text>
       

        </View>
    </View>
  )
}

export default function HomeScreen(props){

  const [done,setDone]=useState('-');
  const [upcoming,setUpcoming]=useState('-');
  const [connectionToast,setConnectionT]=useState(false);
  const [populars,setPopulars]=useState(null);
  const [recommended,setRecommended]=useState(null);

  useEffect(()=>{

    fetch('https://fitwayz.ir/api/classes/passed',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        limit : 1,
        offset : 0,
      })
    })
    .then(response => response.json()).then(responseJson => {
      setDone(responseJson.total);
    })
    .catch(error => {
      setConnectionT(true);
    });


     fetch('https://fitwayz.ir/api/classes/upcoming',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        limit : 1,
        offset : 0,
      })
    })
    .then(response => response.json()).then(responseJson => {
      setUpcoming( responseJson.total);
    })
    .catch(error => {
      setConnectionT(true);
    });



    fetch('https://fitwayz.ir/api/classes/populars',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify([])
    })
    .then(response => response.json()).then(responseJson => {
      console.log(responseJson)
      setPopulars(responseJson.data)
    })
    .catch(error => {
      setConnectionT(true);
    });


    fetch('https://fitwayz.ir/api/classes/recommended',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify([])
    })
    .then(response => response.json()).then(responseJson => {
      console.log(responseJson)
      setRecommended(responseJson.data)
    })
    .catch(error => {
      setConnectionT(true);
    }); 




    fetch('https://fitwayz.ir/api/users/favorites',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify([])
    })
    .then(response => response.json()).then(responseJson => {
      global.favorites = responseJson.favorites;
    })
    .catch(error => {
      setConnectionT(true);
    });

    fetch('https://fitwayz.ir/api/users/info',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify([])
    })
    .then(response => response.json()).then(responseJson => {
      global.credit=responseJson.credit;
      global.creditExpire = responseJson.credit_expires_in;
    })
    .catch(error => {
      setConnectionT(true);
    });


  },[])

    return (
      <View style={{height:Dimensions.get('window').height}}>
      <Appbar.Header style={{paddingHorizontal:20}}>
        <Appbar.Content
          title="فیت وِیز"
        />
         <View style={{paddingHorizontal:8}}>
             <Image style={{ height: 20 ,width:100 }} resizeMode='contain' source={require('../assets/img/logotype.png')}/>
         </View> 
      </Appbar.Header>
      
      <ScrollView>
        
        <Card style={{margin:25, backgroundColor:'#21706c',elevation:5}} onPress={()=>{ 
          let resetAction = CommonActions.reset({
            index: 0,
            routes:[{name:'Profile'},]
          });
          props.navigation.dispatch(resetAction);
          props.navigation.navigate('ProfileRoute')}}>
          <Card.Title titleStyle={{color:'white'}} title="فعالیت های من" left={MyAvatar} />
          <Card.Content style={{flexDirection:'row',justifyContent:'space-between',paddingHorizontal:50,paddingVertical:5}}>
            
            <Text style={{color:'white',fontSize:16}}>گذرانده : {done}</Text>
            <Text style={{color:'white',fontSize:16}}>|</Text>
            <Text style={{color:'white',fontSize:16}}>پیش رو : {upcoming}</Text>
          </Card.Content>
        </Card>

        <Card style={{marginHorizontal:25, backgroundColor:'#f2e5d7',elevation:5}} onPress={()=>{
          props.navigation.navigate('Plans');
        }}>
          <Card.Content style={{flexDirection:'row'}}>

             <View style={{flex:1}}>
               <Text style={{color:'black',fontFamily:'iransansb',fontSize:18,marginHorizontal:10}}>فیت کارت</Text>
               <Text style={{color:'black',fontSize:13,marginHorizontal:10}}>کارت خرید اشتراک</Text>
             </View>

            <Image style={{ height: 70, width:90, marginHorizontal:10 }} resizeMode='contain' source={require('../assets/fitcard.png')}/>

          </Card.Content>
        </Card>

        
        <Card style={{marginHorizontal:25, backgroundColor:'#2ebbc4',elevation:5,marginTop:25}}  onPress={()=>{ 
        global.filters= {
          limit : 10,
          level : 'پیشرفته',
          sports : [],
          facilities : {
            parking : false,
            locker : false,
            towel : false,
            pool : false
          },
          order : null,
          date: null,
          area : null
        } ;
          let resetAction = CommonActions.reset({
            index: 0,
            routes:[{name:'Search'},]
          });
          props.navigation.dispatch(resetAction);
          props.navigation.navigate('SearchRoute')}}>
          <Card.Content style={{flexDirection:'row'}}>

             <View style={{flex:1}}>
               <Text style={{color:'white',fontFamily:'iransansb',fontSize:18,marginHorizontal:10}}>ورزش های آنلاین</Text>
               <Text style={{color:'white',fontSize:14,marginHorizontal:10}}>با مربی دلخواهت هر زمان و هر مکان، آنلاین ورزش کن.</Text>
             </View>

            <Image style={{ height: 85, width:85, marginHorizontal:15,marginTop:-10,marginBottom:-14 }} resizeMode='contain' source={require('../assets/online.png')}/>

          </Card.Content>
        </Card>

       {(populars != null && recommended != null)?
                <>
               <View style={{marginTop:25}}>
               <Text style={{fontSize:16, marginHorizontal:30}}>
                 محبوب ترین های امروز
               </Text>
               <ScrollView contentContainerStyle={{paddingVertical:10,paddingHorizontal:25}} horizontal={true}>
                 {populars.map((item,index)=>{
                   return(
                    <Card key={index} style={{width:270,elevation:5,marginHorizontal:5}}
                    onPress={()=>{
                      global.activeClassId = item.id;
                      global.activeClassInfo = item;
                      props.navigation.push('Class')}}>
                    <Card.Title subtitleStyle={{marginRight:20}} titleStyle={{marginRight:20}} subtitle={item.gymname}  title={item.classname}
                     left={()=> <Avatar.Image style={{backgroundColor:'#21706c'}} size={48} source={sportIcons[item.sport]} />} />
                    <Card.Content>
                      <View style={{flexDirection:'row', justifyContent:'space-between'}}>
                        <View style={{flexDirection:'row'}}>
                        <IconButton icon='human' style={{margin:-7,}}/>
                         <Text numberOfLines={1} style={{maxWidth:125,marginHorizontal:5}}>{item.trainer}</Text>
                        </View>
                        <TimeStamp start={item.starttime} end={item.endtime}/>
                      </View>
                      <Divider style={{marginVertical:15}} />
                      <View style={{flexDirection:'row'}}>
                        <IconButton icon='map-marker-outline' style={{margin:-7}}/>
                        <Text numberOfLines={1} style={{maxWidth:200,marginHorizontal:5}}>{item.address}</Text>
                      </View>
                    </Card.Content>
                    </Card>
                   )
                 })}
               </ScrollView>
               
             </View>

             <View style={{marginTop:20}}>
             <Text style={{fontSize:16, marginHorizontal:30}}>
                انتخاب شده ها
             </Text>
             </View>
             <ScrollView style={{marginBottom:20}} contentContainerStyle={{paddingVertical:10,paddingHorizontal:25}} horizontal={true}>
             

           {recommended.map((item,index)=>{
              return(
                        

                    <Card key={index} style={{width:270,elevation:5,marginHorizontal:5}}
                    onPress={()=>{
                      global.activeClassId = item.id;
                      global.activeClassInfo = item;
                      props.navigation.push('Class')}}>
                    <Card.Title subtitleStyle={{marginRight:20}} titleStyle={{marginRight:20}} subtitle={item.gymname}  title={item.classname}
                     left={()=> <Avatar.Image style={{backgroundColor:'#21706c'}} size={48} source={sportIcons[item.sport]} />} />
                    <Card.Content>
                      <View style={{flexDirection:'row', justifyContent:'space-between'}}>
                        <View style={{flexDirection:'row'}}>
                        <IconButton icon='human' style={{margin:-7,}}/>
                         <Text numberOfLines={1} style={{maxWidth:125,marginHorizontal:5}}>{item.trainer}</Text>
                        </View>
                        <TimeStamp start={item.starttime} end={item.endtime}/>
                      </View>
                      <Divider style={{marginVertical:15}} />
                      <View style={{flexDirection:'row'}}>
                        <IconButton icon='map-marker-outline' style={{margin:-7}}/>
                        <Text numberOfLines={1} style={{maxWidth:200,marginHorizontal:5}}>{item.address}</Text>
                      </View>
                    </Card.Content>
                    </Card>
                    
                    
                   )
                 })}

               </ScrollView>
               
               </>
             
             
             :
             <ActivityIndicator style={{marginTop:30}} animating={true} color='#21706c' />
             }

      </ScrollView>

      <View style={{height:50,backgroundColor:'white',paddingHorizontal:45,flexDirection:'row',justifyContent:'space-between',borderTopLeftRadius:20,borderTopRightRadius:20,borderWidth:0.4,borderTopColor:'grey',borderLeftColor:'grey',borderRightColor:'grey'}}>
        <TouchableOpacity style={{paddingTop:8,marginHorizontal:10}}
        onPress={()=>props.navigation.openDrawer()}>
        <View style={{marginRight:'auto',marginLeft:'auto'}}>
        <IconButton icon='menu' style={{margin:-9}}/>
        </View>
        <Text>منو</Text>
        </TouchableOpacity>



        <TouchableOpacity style={{paddingTop:8}} onPress={()=>props.navigation.navigate('Events') }>
        <View style={{marginRight:'auto',marginLeft:'auto'}}>
        <IconButton icon='calendar' style={{margin:-9}}/>
        </View>
        <Text>اطلاعیه ها</Text>
        </TouchableOpacity>

      </View>

      <View style={{position:'absolute', bottom:0,left:'50%'}}>
      <View style={{position:'relative',left:'-50%'}}>
        <FAB
         style={styles.fab}
         icon="magnify"
         onPress={() => {
          global.filters= {
            limit : 10,
            level : null,
            sports : [],
            facilities : {
              parking : false,
              locker : false,
              towel : false,
              pool : false
            },
            order : null,
            date: null,
            area : null
          } ;
            let resetAction = CommonActions.reset({
              index: 0,
              routes:[{name:'Search'},]
            });
            props.navigation.dispatch(resetAction);
            props.navigation.navigate('SearchRoute')
         }}
        />
        <Text>جستجوی ورزش</Text>
      </View>
      </View>

      <Snackbar
          style={{zIndex:200}}
          visible={connectionToast}
          onDismiss={() => setConnectionT(false)}>
         ارتباط اینترنت با مشکل مواجه است
        </Snackbar>
      </View>
    );
  }

  const styles = StyleSheet.create({
    fab: {
      marginRight:'auto',
      marginLeft:'auto',
      backgroundColor:'#1B7479',
    },
  })
